import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, offer } from '../data/content';
export function Pricing() {
  return <section id="inversion" className="w-full bg-cream py-16 md:py-24" data-id="element-109" data-mp="2aqswh9lrljqf">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-110" data-mp="2oiz1q0ndq6b3">
        <h2 className="mx-auto max-w-xl text-center font-display text-[2rem] font-extrabold leading-[1.12] tracking-tight text-ink md:text-5xl" data-id="element-111" data-mp="2jjmdpckrut6x">
          Oferta especial de lanzamiento
        </h2>

        <div className="relative mx-auto mt-14 max-w-xl rounded-3xl border-2 border-forest-600 bg-white px-6 pb-9 pt-12 md:px-10 md:pb-11" data-id="element-112" data-mp="1rsgcestbepg2">
          <p className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-forest-600 px-5 py-2 font-sans text-xs font-bold uppercase tracking-[0.14em] text-white" data-id="element-113" data-mp="25t9afnits2nx">
            {offer.badge}
          </p>

          <dl className="divide-y divide-gray-200" data-id="element-114" data-mp="3h9hdrr62zi0n">
            {offer.lines.map(line => <div key={line.label} className="flex items-baseline justify-between gap-6 py-4" data-id="element-115" data-mp="3c81tw2fn3hju">
                <dt className="text-base leading-snug text-gray-600" data-id="element-116" data-mp="3vz72o2kemxs4">{line.label}</dt>
                <dd className="shrink-0 font-sans text-base font-bold text-forest-600" data-id="element-117" data-mp="4rkqfljmdmzn">
                  {line.value}
                </dd>
              </div>)}

            <div className="flex items-baseline justify-between gap-6 py-4" data-id="element-118" data-mp="erlflo466xbr">
              <dt className="font-sans text-sm font-bold uppercase tracking-[0.12em] text-ink" data-id="element-119" data-mp="3d97hhqroq2tz">
                Valor total:
              </dt>
              <dd className="shrink-0 font-sans text-base font-bold text-gray-400 line-through" data-id="element-120" data-mp="3i8k204v32xte">
                {offer.totalValue}
              </dd>
            </div>
          </dl>

          <div className="border-b border-gray-200 pb-8 pt-7 text-center" data-id="element-121" data-mp="3rywuqkd1xxam">
            <p className="font-sans text-xs font-bold uppercase tracking-[0.18em] text-forest-600" data-id="element-122" data-mp="2uizhhhja7si0">
              Sólo por hoy
            </p>
            <p className="mt-3 font-display text-6xl font-extrabold leading-none tracking-tight text-forest-600 md:text-7xl" data-id="element-123" data-mp="2zfzphxzoz5br">
              {offer.price}
            </p>
            <p className="mt-3 font-sans text-sm font-semibold text-gray-400" data-id="element-124" data-mp="2mijq13be7lvi">
              Valor regular <span className="line-through" data-id="element-125" data-mp="316xqj7lc6y8w">{offer.listPrice}</span> {offer.currency}
            </p>
          </div>

          <p className="pt-7 text-center text-sm text-gray-500" data-id="element-126" data-mp="2w8w90r3k76zj">{offer.microcopy}</p>

          <div className="mt-6" data-id="element-127" data-mp="28h7dl1vfy2ed">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-128" data-mp="28i8zy2hwqbbe">
              {offer.cta}
            </CtaButton>
          </div>

          <p className="mt-6 text-center text-sm text-gray-400" data-id="element-129" data-mp="2ifwv2tjfdku3">{offer.reassurance}</p>
        </div>
      </div>
    </section>;
}